module.exports = __webpack_public_path__ + "img/kommune-1519.a302e20f.svg";